import React, { useState, useEffect } from 'react';
import Header from '../components/header';
import PageMenu from '../components/pagemenu';
import './accounts.css';
import Customers from '../components/customers';


function Accounts() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check for auth token in localStorage on component mount
    const token = localStorage.getItem('authToken');
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <div className="App">
      <Header isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
      {isAuthenticated ? (
        <div className='content'>
        <Customers />
      </div>
      ) : (
        <div>Please log in to view content</div>
      )}
      {/* Bottom navigation for mobile */}
      <PageMenu className="bottom-nav" />
    </div>
  );
}

export default Accounts;
